import { render, staticRenderFns } from "./SsSelectSearchInput.vue?vue&type=template&id=52ee95f0&"
import script from "./SsSelectSearchInput.vue?vue&type=script&lang=js&"
export * from "./SsSelectSearchInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports